import { style } from '@vanilla-extract/css';

export const sup = style({
  textDecoration: 'underline',
  fontVariantNumeric: 'tabular-nums',
});
